import React, { useEffect, useState } from "react";
import { domain } from "../../assets/js/api";
import parse from 'html-react-parser';
import { getImageSize } from 'react-image-size';
import { useLocation } from 'react-router-dom';

const SectionDark = ({period, section, id}) => {
  const [image, setImage] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (period.image) {
      getImageSize(domain + period.image.image).then(res => {
        period.image.isWide = res.width > res.height;
        setImage(period.image);
      });
    }
  }, []);

  useEffect(() => {
    const hash = location.hash;
    if (hash && hash == `#${id}`) {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: 'start' });
      }
    }
  }, [location, id]);

  return <div id ={id ? id : ""} className={section ? "section-expo section has-background-primary has-text-white" : "section has-background-primary has-text-white"}>
        <div className="wrapper is-relative">
          <div className="columns is-desktop is-variable is-8">
            <div className="column is-one-third-widescreen flow--l">
              <div className="timespan is-flex is-justify-content-space-between has-text-weight-bold is-family-secondary">
                <span className="pb-3">{period.start}</span>
                <span className="pb-3">{period.end}</span>
              </div>
              <h2 className="bg-title has-text-centered is-size-1 has-text-primary has-text-weight-bold">
                {period.title}
              </h2>
              {image?
              <figure className="is-hidden-desktop">
                <div className="full-bleed">
                  <img loading="lazy" src={domain + image.image} alt="" />
                </div>
                <figcaption>{image.footprint}</figcaption>
              </figure>
              :''}
              <div className="flow">
                {parse(period.body)}
              </div>
            </div>
            <div className="column is-hidden-touch">
            {image?
              <figure className={image.isWide ? "is-landscape" : "is-portrait"}>
                <img loading="lazy" src={domain + image.image} alt="" />
                <figcaption>{image.footprint}</figcaption>
              </figure>
            :''}
            </div>
          </div>
        </div>
      </div>
    ;




  /*function createYears() {
    if (years) {
      let hasCombined = false;
      return years.map((res, index) => {
        if (res.term === 1936 && !hasCombined) {
          hasCombined = true;
          const combinedSectionIds = [res.section_id];
          for (let i = index + 1; i < years.length; i++) {
            const nextRes = years[i];
            if (nextRes.term === 1936) {
              combinedSectionIds.push(nextRes.section_id);
            }
          }
          return <SectionWhite key={combinedSectionIds.join('-')} id={combinedSectionIds.join('-')}></SectionWhite>;
        } else {
          return <SectionWhite key={res.section_id} id={res.section_id}></SectionWhite>;
        }
      });
    } else {
      return <div className="loader1"></div>;
    }
  }*/
};

export default SectionDark;
